<div class="documents-list">
  <div class="document-not-found" data-qa-block="empty-list" *ngIf="documents.length === 0">
    {{ 'documents.empty_list' | translate }}
  </div>

  <div class="ui-kit-item-list-container" data-qa="documents-list" *ngIf="documents.length > 0">
    <ng-container *ngFor="let document of documents; let i = index; trackBy: trackById">
      <tax-document *ngIf="i < countDisplayedDocuments" [document]="document"></tax-document>
    </ng-container>
  </div>

  <button
    class="load-more"
    data-qa-button="load-more"
    *ngIf="documents.length > countDisplayedDocuments"
    (click)="loadMoreDocuments()"
  >
    {{ 'documents.load_more' | translate }}
  </button>
</div>
